<template>
  <div>
    <el-card class="box-card"
      v-for="(product,idx) in products"
      :key="product.id">
      <el-row :gutter="20">
        <el-col :xs="24">
          <text-field
            v-model="product.product_name"
            :base="base"
            name="product_name"
            :labelText="getProductLabel(idx)"
            disabled
            >
          </text-field>
        </el-col>
        <el-col :xs="24" :md="12">
          <text-field
            v-model="product.product_id"
            :base="base"
            name="product_id"
            disabled
            >
          </text-field>
        </el-col>
        <el-col :xs="24" :md="12">
          <text-field
            v-model="product.unhide_pid"
            :base="base"
            name="unhide_pid"
            disabled
            >
          </text-field>
        </el-col>
        <el-col :xs="24" :md="12">
          <text-field
            v-if="product.price !== undefined"
            v-model.number="product.price"
            :base="base"
            name="price"
            disabled
            >
            <template slot="prepend-input">{{ currency }}</template>
          </text-field>
          <text-field
            v-if="product.unit_price !== undefined"
            v-model.number="product.unit_price"
            :base="base"
            name="price"
            disabled
            >
            <template slot="prepend-input">{{ currency }}</template>
          </text-field>
        </el-col>
        <el-col :xs="24" :md="12">
          <text-field
            v-model.number="product.quantity"
            :base="base"
            name="quantity"
            disabled
            >
          </text-field>
        </el-col>
      </el-row>
      <el-row
        v-if="isPayment"
        :gutter="20"
      >
        <el-col :xs="24" :md="12">
          <text-field
            v-model.number="product.net_price"
            base="payment"
            name="net_price"
            disabled
          >
            <template slot="prepend-input">{{ currency }}</template>
          </text-field>
        </el-col>
        <el-col :xs="24" :md="12">
          <text-field
            v-model.number="product.fee"
            base="payment"
            name="fee"
            disabled
          >
            <template slot="append-input">％</template>
          </text-field>
        </el-col>
        <el-col :xs="24" :md="12">
          <text-field
            v-model.number="product.orders_amount"
            base="payment"
            name="orders_amount"
            disabled
          >
            <template slot="prepend-input">{{ currency }}</template>
          </text-field>
        </el-col>
        <el-col :xs="24" :md="12">
          <text-field
            v-model.number="product.allow_amount"
            base="payment"
            name="allow_amount"
            disabled
          >
            <template slot="prepend-input">{{ currency }}</template>
          </text-field>
        </el-col>
        <el-col :xs="24" :md="12">
          <text-field
            v-model.number="product.collection_amount"
            base="payment"
            name="collection_amount"
            disabled
          >
            <template slot="prepend-input">{{ currency }}</template>
          </text-field>
        </el-col>
        <el-col :xs="24" :md="12">
          <text-field
            v-model.number="product.commission"
            base="payment"
            name="commission"
            disabled
          >
            <template slot="prepend-input">{{ currency }}</template>
          </text-field>
        </el-col>
        <el-col :xs="24">
          <text-field
            v-model.number="product.transfer_amount"
            base="payment"
            name="transfer_amount"
            disabled
          >
            <template slot="prepend-input">{{ currency }}</template>
          </text-field>
        </el-col>
      </el-row>
      <el-row
        v-if="product.start_time !== null"
        :gutter="20"
      >
        <el-col :xs="24" :md="12">
          <time-field
            v-model="product.start_time"
            :base="base"
            name="start_time"
            placeholderText=""
            :tzLocation="tzLocation"
            readonly
            disabled
            >
          </time-field>
        </el-col>
        <el-col :xs="24" :md="12">
          <time-field
            v-model="product.end_time"
            :base="base"
            name="end_time"
            placeholderText=""
            :tzLocation="tzLocation"
            readonly
            disabled
            >
          </time-field>
        </el-col>
      </el-row>
      <el-row v-if="sub_items.length > 0" :gutter="20">
        <el-col>
          <el-card
            class="box-card"
            style="margin-bottom: 0px"
            >
            <div slot="header" class="clearfix">
              {{ $t('api.orders.sub_item.name') }}
            </div>
            <el-tree :data="getSubItemData(product)"></el-tree>
          </el-card>
        </el-col>
      </el-row>
    </el-card>
    <el-card class="box-card"
      v-for="upgrade in upgrades"
      :key="'upg' + upgrade.id">
      <el-row :gutter="20">
        <el-col :xs="24" :md="12">
          <text-field
            v-model="upgrade.upgrade_name"
            :base="base"
            name="upgrade_name"
            disabled
            >
          </text-field>
        </el-col>
        <el-col :xs="24" :md="12">
          <text-field
            v-model="upgrade.upgrade_id"
            :base="base"
            name="upgrade_id"
            :disabled="true">
          </text-field>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :xs="24" :md="12">
          <text-field
            v-if="upgrade.price !== undefined"
            v-model.number="upgrade.price"
            :base="base"
            name="price"
            disabled
            >
            <template slot="prepend-input">{{ currency }}</template>
          </text-field>
          <text-field
            v-if="upgrade.unit_price !== undefined"
            v-model.number="upgrade.unit_price"
            :base="base"
            name="price"
            disabled
            >
            <template slot="prepend-input">{{ currency }}</template>
          </text-field>
        </el-col>
        <el-col :xs="24" :md="12">
          <text-field
            v-model.number="upgrade.quantity"
            :base="base"
            name="quantity"
            disabled
            >
          </text-field>
        </el-col>
      </el-row>
      <el-row
        v-if="isPayment"
        :gutter="20"
      >
        <el-col :xs="24" :md="12">
          <text-field
            v-model.number="upgrade.net_price"
            base="payment"
            name="net_price"
            disabled
          >
            <template slot="prepend-input">{{ currency }}</template>
          </text-field>
        </el-col>
        <el-col :xs="24" :md="12">
          <text-field
            v-model.number="upgrade.fee"
            base="payment"
            name="fee"
            disabled
          >
            <template slot="append-input">％</template>
          </text-field>
        </el-col>
        <el-col :xs="24" :md="12">
          <text-field
            v-model.number="upgrade.orders_amount"
            base="payment"
            name="orders_amount"
            disabled
          >
            <template slot="prepend-input">{{ currency }}</template>
          </text-field>
        </el-col>
        <el-col :xs="24" :md="12">
          <text-field
            v-model.number="upgrade.allow_amount"
            base="payment"
            name="allow_amount"
            disabled
          >
            <template slot="prepend-input">{{ currency }}</template>
          </text-field>
        </el-col>
        <el-col :xs="24" :md="12">
          <text-field
            v-model.number="upgrade.collection_amount"
            base="payment"
            name="collection_amount"
            disabled
          >
            <template slot="prepend-input">{{ currency }}</template>
          </text-field>
        </el-col>
        <el-col :xs="24" :md="12">
          <text-field
            v-model.number="upgrade.commission"
            base="payment"
            name="commission"
            disabled
          >
            <template slot="prepend-input">{{ currency }}</template>
          </text-field>
        </el-col>
        <el-col :xs="24">
          <text-field
            v-model.number="upgrade.transfer_amount"
            base="payment"
            name="transfer_amount"
            disabled
          >
            <template slot="prepend-input">{{ currency }}</template>
          </text-field>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>

import { getTransText } from '@/utils/i18n'

export default {
  name: 'orders-product',
  props: {
    base: {
      type: String,
      default: ''
    },
    isPayment: {
      type: Boolean,
      default: false
    },
    currency: {
      type: String,
      default: ''
    },
    products: {
      type: Array,
      default: () => []
    },
    tzLocation: {
      type: String,
      default: ''
    },
    upgrades: {
      type: Array,
      default: () => []
    },
    sub_items: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
    }
  },
  methods: {
    getTransText,
    getProductLabel (idx) {
      return (idx === 0)
        ? this.$t('api.orders.fields.product_name.main')
        : this.$t('api.orders.fields.product_name.add')
    },
    getSubItemData (product) {
      var items = this.sub_items.filter(item => {
        return item.orders_product_id === product.id
      })

      var data = []
      items.forEach(item => {
        if (!data[item.split_qty_index]) {
          data[item.split_qty_index] = { label: product.product_name, children: [] }
        }

        if (item.qty === 0) {
          return
        }

        var totalPrice = (item.qty - item.free_qty) * item.price
        if (totalPrice < 0) {
          totalPrice = 0
        }
        var label = this.$t('api.orders.sub_item.info', {
          name: item.name,
          qty: item.qty,
          price: item.price,
          freeQty: item.free_qty,
          totalPrice: totalPrice
        })
        data[item.split_qty_index].children.push({label: label})
      })

      return data
    }
  },
  mounted () {
  },
  watch: {
  }
}
</script>
